import React from 'react'
import { Line } from 'react-chartjs-2'
import styled from 'styled-components'

export default function Graph({ show }) {
  return (
    <GraphWrapper>
      <Line
        data={getData(show)}
        options={{
          showLines: false,
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  suggestedMin: 0,
                  suggestedMax: 10,
                },
                gridLines: {
                  color: 'rgba(255, 255, 255, 0.1)',
                },
              },
            ],
            xAxes: [
              {
                ticks: {
                  maxTicksLimit: 30,
                  display: false,
                },
                gridLines: {
                  display: false,
                },
              },
            ],
          },
        }}
      />
    </GraphWrapper>
  )
}

const colors = [
  '#00b894',
  '#fdcb6e',
  '#e84393',
  '#0984e3',
  '#d63031',
  '#00cec9',
  '#6c5ce7',
  '#e17055',
]

const pointStyles = [
  'rect',
  'cross',
  'triangle',
  'circle',
  'crossRot',
  'rectRounded',
  'rectRot',
]

const getData = (show) => {
  const episodeNumbers = show.seasons
    .flatMap((x) => x.episodes)
    .map((x, i) => i + 1)
  const labels = [
    0,
    ...episodeNumbers,
    episodeNumbers[episodeNumbers.length - 1] + 1,
  ]

  const { datasets } = show.seasons.reduce(
    (aggregate, season, idx) => {
      const color = colors[idx % colors.length]
      const dataset = {
        label: show.title + idx,
        fill: false,
        lineTension: 0.1,
        borderColor: color,
        pointBackgroundColor: color,
        pointStyle: pointStyles[idx % pointStyles.length],
        pointRadius: 5,
        data: season.episodes.map((e, i) => ({
          x: i + 1 + aggregate.episodeCount,
          y: e.rating,
        })),
      }

      aggregate.datasets = [...aggregate.datasets, dataset]
      aggregate.episodeCount += season.episodes.length

      return aggregate
    },
    {
      episodeCount: 0,
      datasets: [],
    }
  )

  return {
    labels,
    datasets,
  }
}

const GraphWrapper = styled.div`
  max-width: 90%;
  width: 100%;
  height: 100%;
`
